import script from "./VehicleDetailsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleDetailsHeader.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleDetailsHeader.vue?vue&type=style&index=0&id=78c8017c&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78c8017c"]])

export default __exports__